// Client-side wrapper for the WhatsApp contact-share consent flow.
// Viewer requests → owner approves/denies → viewer sees the number.

import {
  collection, doc, onSnapshot, query, where, orderBy, limit,
} from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { db, functions } from "../firebase";

const COL = "pop_market_contact_requests";

export const requestContact = httpsCallable(functions, "popMarketRequestContact");
export const respondContact = httpsCallable(functions, "popMarketRespondContact");

// Live subscribe to a specific (fromUid, toUid) pair so the viewer's
// UI reflects status changes (pending → approved → number revealed)
// the moment the owner responds. Returns the unsubscribe fn.
export function subscribeMyRequestFor({ fromUid, toUid, channel = "whatsapp" }, cb) {
  if (!fromUid || !toUid) { cb(null); return () => {}; }
  const q = query(
      collection(db, COL),
      where("fromUid", "==", fromUid),
      where("toUid", "==", toUid),
      where("channel", "==", channel),
      limit(1),
  );
  return onSnapshot(q,
      (snap) => cb(snap.empty ? null : { id: snap.docs[0].id, ...snap.docs[0].data() }),
      (err) => {
        console.warn("[pop-market] subscribeMyRequestFor failed", err);
        cb(null);
      },
  );
}

// Live subscribe to the owner's pending inbox — everyone who has
// asked for their WhatsApp and is still waiting for a response.
export function subscribeMyIncomingPending(ownerUid, cb) {
  if (!ownerUid) { cb([]); return () => {}; }
  const q = query(
      collection(db, COL),
      where("toUid", "==", ownerUid),
      where("status", "==", "pending"),
      orderBy("createdAt", "desc"),
      limit(50),
  );
  return onSnapshot(q,
      (snap) => cb(snap.docs.map((d) => ({ id: d.id, ...d.data() }))),
      (err) => {
        console.warn("[pop-market] subscribeMyIncomingPending failed", err);
        cb([]);
      },
  );
}
